import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import requestCheck from 'assets/images/Dashboard/chevron-right-request.svg';
import { getPatientDetailData } from 'store/patientDetail/patinetDetailAction';
import ArrowDetail from 'assets/images/Dashboard/arrow-left-request-detail.svg';
import MobileIcon from 'assets/images/Dashboard/call-request-detail.svg';
import MailIcon from 'assets/images/Dashboard/mail-request-detail.svg';
import ImageNull from 'assets/images/Dashboard/image-null.svg';
import moment from 'moment';
import { ClearTokenRedirectLogin } from 'utils/general';
import Shimmer from 'components/commom/Shimmer';
import PatientDetailAppointment from './PatientDetailAppointment';
import CommonToast from 'components/commom/CommonToast';
import ReusableTabs from 'components/commom/Tab';
import PatientDetailSkinAnalysis from './PatientDetailSkinAnalysis';
import skinAnalyser from 'assets/images/Enterprise/Skin Analyser.png';
import skinConcern from 'assets/images/Enterprise/Skin Concern Identifier.png';
import telemedicine from 'assets/images/Enterprise/Telemedicine.png';
import { patients } from 'routes/AppUrls';
import { deletePatientData } from 'store/patientListDelete/patientListDeleteAction';
import CommonModal from 'components/commom/Modal';
import ReusableButton from 'components/commom/Button';
import DeleteList from 'assets/images/Dashboard/delete.svg';

const PatientDetail = () => {
  const { locale } = useContext(LocaleContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const [patientDetailValue, setPatientDetailValue] = useState();
  const [tab, setTab] = useState(1);
  const [deleteModal, setDeleteModal] = useState(false);

  const patientDetailReducer = useSelector(
    (state) => state?.patientDetailReducer?.loading
  );
  const patientId = useSelector(
    (state) => state?.basicDetailsValueReducer?.patientId
  );
  const deleteLoading = useSelector(
    (state) => state?.deletepatientListReducer?.loading
  );

  const tabData = [
    { label: 'Appointment History' },
    { label: 'Skin Analyser' },
  ];

  const numberData = [
    { id: 1, name: 'Skin Analysis', img: skinAnalyser },
    { id: 2, name: 'SkinConcern Identifier', img: skinConcern },
    { id: 3, name: 'Telemedicine', img: telemedicine },
  ];

  useEffect(() => {
    getPatientDetail();
  }, []);

  const handleTabChange = (val) => {
    setTab(val);
  };

  const getPatientDetail = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setPatientDetailValue(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getPatientDetailData(external, patientId));
  };

  const deletePatientListData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        setDeleteModal(false);
        navigate(patients(locale));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(deletePatientData(external, patientId));
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainerrequest lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainerrequest lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="flex pb-16">
            <div className="fs-12 lh-24 family_outfit_regular_400">
              Requests
            </div>
            <div className="pl-04 flex items-center">
              <Image src={requestCheck} alt="icon" />
            </div>
            <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
              Patient Details
            </div>
          </div>
          <Row className="bg-light-100 m-0 p-24">
            <Col sm={12} className="p-0">
              <div className="flex justify-between gap-[20px]">
                <div className="flex">
                  <div>
                    <Image
                      src={ArrowDetail}
                      alt="icon"
                      onClick={() => navigate(-1)}
                      className="cursor-pointer"
                    />
                  </div>
                  <div className="fs-20 lh-252 family_outfit_semiBold_600 fc-292D32 pl-12">
                    Patient Details
                  </div>
                </div>
                <Image
                  src={DeleteList}
                  alt="icon"
                  onClick={() => setDeleteModal(true)}
                  className="cursor-pointer"
                />
              </div>
              <Row className="m-0 p-0">
                <Col md={4} className="p-0">
                  <div className="flex align-items-center pt-16">
                    <div className="uploadPhoto">
                      {patientDetailReducer ? (
                        <Shimmer
                          width="100px"
                          height="100px"
                          borderRadius="50%"
                        />
                      ) : (
                        <Image
                          src={
                            patientDetailValue?.patient_details
                              ?.profile_image !== ''
                              ? patientDetailValue?.patient_details
                                  ?.profile_image
                              : ImageNull
                          }
                          alt="Uploaded profile"
                          className={
                            patientDetailValue?.patient_details?.profile_image
                              ? 'uploadPhoto'
                              : ''
                          }
                        />
                      )}
                    </div>
                    <div className="pl-12">
                      {patientDetailReducer ? (
                        <Shimmer width="250px" height="20px" />
                      ) : (
                        <p className="p-0 m-0 fs-20 family_outfit_medium_500 lh-252 fc-202224">
                          {patientDetailValue?.patient_details?.patient_name}
                        </p>
                      )}
                      {patientDetailReducer ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'12px'}
                        />
                      ) : (
                        <p className="pt-12 m-0 fs-14 family_outfit_regular_400 lh-176 fc-A4AAB2">
                          ID:
                          <span className="fs-14 family_outfit_medium_500 lh-176 fc-202224">
                            {patientDetailValue?.patient_details?.patient_id}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                </Col>
                <Col md={8} className="p-0">
                  <Row className="p-0 m-0">
                    <Col md={8} className="p-0 m-0">
                      <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                        Contact Info
                      </div>
                      <Stack
                        direction="horizontal"
                        gap={5}
                        className="items-center p-0"
                      >
                        {patientDetailReducer ? (
                          <Shimmer
                            width="150px"
                            height="20px"
                            marginTop={'8px'}
                          />
                        ) : (
                          <div className="flex pt-8">
                            <div>
                              <Image src={MobileIcon} alt="icon" />
                            </div>
                            <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pl-12">
                              {
                                patientDetailValue?.patient_details
                                  ?.patient_phone
                              }
                            </div>
                          </div>
                        )}
                        {patientDetailReducer ? (
                          <Shimmer
                            width="150px"
                            height="20px"
                            marginTop={'8px'}
                          />
                        ) : (
                          <div className="flex pt-8">
                            <div>
                              <Image src={MailIcon} alt="icon" />
                            </div>
                            <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pl-12 break-all ...">
                              {
                                patientDetailValue?.patient_details
                                  ?.patient_email
                              }
                            </div>
                          </div>
                        )}
                      </Stack>
                    </Col>
                    <Col md={4} className="p-0 m-0">
                      <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-16">
                        Joining Date
                      </div>
                      {patientDetailReducer ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'8px'}
                        />
                      ) : (
                        <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                          {moment(
                            patientDetailValue?.patient_details?.date_joined
                          ).format('DD MMM YYYY')}
                        </div>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          {patientDetailValue?.patient_details?.subscription_plan && (
            <div className="mt-[16px] flex flex-wrap gap-[12px]">
              {numberData?.map((item) => (
                <div
                  className="w-full max-w-[250px] p-[12px] bg-[#FAF1EC]"
                  key={item?.id}
                >
                  <div className="flex items-center gap-[5px]">
                    <Image src={item?.img} alt="icon" />
                    <div className="text-[16px] lh-176 text-[#998A7B] family_outfit_regular_400">
                      {item?.name}:
                    </div>
                    <div className="text-[16px] lh-176 text-[#292D32] family_outfit_medium_500">
                      {item?.id === 1
                        ? patientDetailValue?.patient_details?.subscription_plan
                            ?.used_haut_ai_scan
                        : item?.id === 2
                          ? patientDetailValue?.patient_details
                              ?.subscription_plan?.used_visualdx_scan
                          : item?.id === 3
                            ? patientDetailValue?.patient_details
                                ?.total_consultations
                            : ''}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          <Row className="bc-FEF9F6 m-0 pt-32 pb-12">
            <Col md={12} lg={5} xxl={4} className="p-0">
              <ReusableTabs
                tabs={tabData}
                defaultTab={tab}
                currentTab={(val) => handleTabChange(val)}
                background={'#864629'}
                color={'#FFFFFF'}
                tabColor={'#A2A2A2'}
                completeColor={'#FFFFFF'}
                boxShadow={'0px 3px 16px 0px #00000014'}
              />
            </Col>
          </Row>
          {tab === 1 && <PatientDetailAppointment />}
          {tab === 2 && <PatientDetailSkinAnalysis />}

          {/* delete modal */}
          <CommonModal
            padding={'24px'}
            width={'500px'}
            modalActive={deleteModal}
            innerContent={
              <div>
                <Row>
                  <Col xs={12}>
                    <div className="">
                      <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                        Are you sure you want to delete?
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={12} className="mt-3 flex justify-end">
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center justify-end p-0"
                    >
                      <ReusableButton
                        fullWidth={false}
                        variant="outlined"
                        color="#3C3C3C"
                        fontSize="14px"
                        fontWeight="500"
                        padding="12px 50px"
                        height="44px"
                        bgColor="transparent"
                        brColor="#EFE3D7"
                        fontFamily="outfit_medium"
                        onClick={() => setDeleteModal(false)}
                      >
                        Cancel
                      </ReusableButton>

                      <ReusableButton
                        fullWidth={false}
                        variant="contained"
                        color="#F5F5F5"
                        fontSize="14px"
                        fontWeight="500"
                        padding="12px 50px"
                        height="44px"
                        bgColor="#375241"
                        brColor="#375241"
                        fontFamily="outfit_medium"
                        onClick={() => {
                          !deleteLoading && deletePatientListData();
                        }}
                        loading={deleteLoading}
                      >
                        Delete
                      </ReusableButton>
                    </Stack>
                  </Col>
                </Row>
              </div>
            }
          />
          {/* delete modal */}
        </Col>
      </Row>
    </div>
  );
};

export default PatientDetail;
